import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const OpenLinkDialog = ({ openUrl, clearUrl, sendLog }) => {
    // 处理点击 OK 的逻辑
    const handleOkClick = () => {
        if (openUrl) {
            window.open(openUrl);
            clearUrl();
            sendLog("openlink_click_open")
        }
    };

    // 处理点击 Close 或遮罩层的逻辑
    const handleCloseClick = () => {
        clearUrl();
        sendLog("openlink_click_close")
    };

    return (
        <Dialog open={openUrl != null} onClose={handleCloseClick}>
            <DialogTitle>Tip</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    click "ok" redirect to new page
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleOkClick} autoFocus>Ok</Button>
                <Button onClick={handleCloseClick}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OpenLinkDialog;